export const DUPLICATE_LIST_NAME_MESSAGE = 'A list with this name already exists.';

export const LIST_NAME_MAX_LENGTH = 100;

export const isDuplicateListNameError = (error: unknown): boolean => {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    if ((error as { status?: number }).status === 409) return true;
  }
  const message = error instanceof Error ? error.message.toLowerCase() : '';
  return (
    message.includes('already exists') ||
    message.includes('already in use') ||
    message.includes('duplicate') ||
    message.includes('unique') ||
    message.includes('exist')
  );
};

export const isListNotFoundError = (error: unknown): boolean => {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const status = (error as { status?: number }).status;
    if (status === 404) return true;
  }

  const message = error instanceof Error ? error.message.toLowerCase() : '';
  return message.includes('not found') || message.includes('404') || message.includes('does not exist');
};
